var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [
        _vm._v(_vm._s(_vm.$t("travelService.orderServicesCustomerForm.title")))
      ]),
      _c(
        "v-alert",
        {
          attrs: {
            value: _vm.isInsurance,
            color: "error darken-4",
            outlined: ""
          }
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("travelService.insuranceWarning"))
            }
          })
        ]
      ),
      _c(
        "v-data-table",
        {
          attrs: {
            headers: _vm.headers,
            items: _vm.contextEditedTravelServiceOrder.travelServiceOrderItems,
            loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
            "hide-default-footer": "",
            "footer-props": {
              "items-per-page-options": [
                { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
              ]
            }
          },
          scopedSlots: _vm._u([
            {
              key: "no-data",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "white--text font-weight-bold info pa-5",
                      staticStyle: { width: "100%" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "travelService.orderServicesCustomerForm.noData"
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "item",
              fn: function(props) {
                return [
                  _c("tr", [
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.$t("travelService.types." + props.item.type))
                      )
                    ]),
                    _c(
                      "td",
                      [
                        _c("order-services-request-dates", {
                          attrs: { "order-service-item": props.item }
                        })
                      ],
                      1
                    ),
                    _c(
                      "td",
                      [
                        props.item.type === "hotel"
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.allRoomTypes().find(function(v) {
                                      return (
                                        v.value ===
                                        props.item.travelServiceOrderItemHotel
                                          .room_type
                                      )
                                    }).text
                                  ) +
                                  " "
                              ),
                              _c("br"),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters[
                                      "Location/getLocationText"
                                    ](
                                      props.item.travelServiceOrderItemHotel
                                        .place_id
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        props.item.type === "flight"
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.fromPlace"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters[
                                      "Location/getLocationText"
                                    ](
                                      props.item.travelServiceOrderItemFlight
                                        .start_place_id
                                    )
                                  )
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.toPlace"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters[
                                      "Location/getLocationText"
                                    ](
                                      props.item.travelServiceOrderItemFlight
                                        .end_place_id
                                    )
                                  )
                                )
                              ]),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.class"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.allFlightClassTypes().find(function(v) {
                                      return (
                                        v.value ===
                                        props.item.travelServiceOrderItemFlight
                                          .seat_class
                                      )
                                    }).text
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        props.item.type === "rail"
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.fromPlace"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters[
                                      "Location/getLocationText"
                                    ](
                                      props.item.travelServiceOrderItemRail
                                        .start_place_id,
                                      "train_station"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.toPlace"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters[
                                      "Location/getLocationText"
                                    ](
                                      props.item.travelServiceOrderItemRail
                                        .end_place_id,
                                      "train_station"
                                    )
                                  )
                                )
                              ]),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.class"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.allRailClassTypes().find(function(v) {
                                      return (
                                        v.value ===
                                        props.item.travelServiceOrderItemRail
                                          .seat_class
                                      )
                                    }).text
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        props.item.type === "car"
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.fromPlaceCar"
                                    )
                                  ) +
                                  " "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters[
                                      "Location/getLocationText"
                                    ](
                                      props.item.travelServiceOrderItemCar
                                        .start_place_id
                                    )
                                  )
                                )
                              ]),
                              props.item.travelServiceOrderItemCar
                                .end_place_id != null &&
                              props.item.travelServiceOrderItemCar.end_place_id
                                .length > 0
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "travelService.orderServicesCustomerForm.toPlaceCar"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$store.getters[
                                            "Location/getLocationText"
                                          ](
                                            props.item.travelServiceOrderItemCar
                                              .end_place_id
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.carClass"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.allCarTypes().find(function(v) {
                                      return (
                                        v.value ===
                                        props.item.travelServiceOrderItemCar
                                          .car_class
                                      )
                                    }).text
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        props.item.type === "other"
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "travelService.orderServicesCustomerForm.service"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("b", [_vm._v(_vm._s(props.item.params))])
                            ])
                          : _vm._e(),
                        props.item.type === "insurance"
                          ? _c("span", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters[
                                      "Location/getLocationText"
                                    ](
                                      props.item.travelServiceOrderItemInsurance
                                        .place_id
                                    )
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" " + _vm._s(props.item.comment) + " "),
                        _c("br"),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "travelService.orderServicesCustomerForm.user"
                              )
                            ) +
                            ": "
                        ),
                        _vm._l(
                          props.item.travelServiceOrderItemPassengers,
                          function(user) {
                            return _c("span", { key: user.passenger_id }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(user.name) + " " + _vm._s(user.surname)
                                )
                              ]),
                              _vm._v(", ")
                            ])
                          }
                        ),
                        _c("br"),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "travelService.orderServicesCustomerForm.costCentre"
                              )
                            ) +
                            ": "
                        ),
                        _c("b", [_vm._v(_vm._s(props.item.cost_centre))])
                      ],
                      2
                    ),
                    _vm.canBeEdited
                      ? _c(
                          "td",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.edit(props.item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("edit")])],
                              1
                            ),
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  disabled: !(
                                    typeof props.item.status != "undefined" &&
                                    props.item.status !== 1
                                  ),
                                  bottom: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  disabled:
                                                    typeof props.item.status !=
                                                      "undefined" &&
                                                    props.item.status !== 1,
                                                  icon: ""
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.removeItem(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_c("v-icon", [_vm._v("delete")])],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "travelService.orderServicesCustomerForm.attachedResponse"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.canBeEdited ? _c("td") : _vm._e()
                  ])
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "footer" }, [
            !_vm.canBeEdited
              ? _c("td", { attrs: { colspan: "100%" } }, [
                  _c("h4", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "travelService.orderServicesCustomerForm.noPermissionsForAdding"
                          )
                        ) +
                        " "
                    )
                  ])
                ])
              : _vm._e(),
            _vm.canBeEdited
              ? _c("div", { staticStyle: { "text-align": "center" } }, [
                  _vm.$store.getters["userProperties"].system_settings
                    .travel_service_flight_available
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "pa-4 text-md-center elevation-5 ma-3 add-service-buttons",
                          on: {
                            click: function($event) {
                              return _vm.$store.dispatch(
                                "TravelService/createFlightItem"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "padding-left": "37px" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "font-size": "60px" },
                                  attrs: { color: "primary" }
                                },
                                [_vm._v("fa-plane")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "plus-button",
                                  attrs: {
                                    color: "success",
                                    "x-small": "",
                                    fab: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("fa-plus")])],
                                1
                              )
                            ],
                            1
                          ),
                          _c("h3", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "travelService.orderServicesCustomerForm.orderFlight"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.$store.getters["userProperties"].system_settings
                    .travel_service_rail_available
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "pa-4 text-md-center elevation-5 ma-3 add-service-buttons",
                          on: {
                            click: function($event) {
                              return _vm.$store.dispatch(
                                "TravelService/createRailItem"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "padding-left": "37px" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "font-size": "60px" },
                                  attrs: { color: "primary" }
                                },
                                [_vm._v("fa-train")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "plus-button",
                                  attrs: {
                                    color: "success",
                                    "x-small": "",
                                    fab: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("fa-plus")])],
                                1
                              )
                            ],
                            1
                          ),
                          _c("h3", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "travelService.orderServicesCustomerForm.orderRail"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.$store.getters["userProperties"].system_settings
                    .travel_service_car_available
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "pa-4 text-md-center elevation-5 ma-3 add-service-buttons",
                          on: {
                            click: function($event) {
                              return _vm.$store.dispatch(
                                "TravelService/createCarItem"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "padding-left": "37px" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "font-size": "60px" },
                                  attrs: { color: "primary" }
                                },
                                [_vm._v("fa-car")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "plus-button",
                                  attrs: {
                                    color: "success",
                                    "x-small": "",
                                    fab: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("fa-plus")])],
                                1
                              )
                            ],
                            1
                          ),
                          _c("h3", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "travelService.orderServicesCustomerForm.orderCar"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.$store.getters["userProperties"].system_settings
                    .travel_service_hotel_available
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "pa-4 text-md-center elevation-5 ma-3 add-service-buttons",
                          on: {
                            click: function($event) {
                              return _vm.$store.dispatch(
                                "TravelService/createHotelItem"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "padding-left": "37px" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "font-size": "60px" },
                                  attrs: { color: "primary" }
                                },
                                [_vm._v("fa-hotel")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "plus-button",
                                  attrs: {
                                    color: "success",
                                    "x-small": "",
                                    fab: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("fa-plus")])],
                                1
                              )
                            ],
                            1
                          ),
                          _c("h3", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "travelService.orderServicesCustomerForm.orderHotel"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pa-4 text-md-center elevation-5 ma-3 add-service-buttons",
                      on: {
                        click: function($event) {
                          return _vm.$store.dispatch(
                            "TravelService/createOtherItem"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "padding-left": "37px" } },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "font-size": "60px" },
                              attrs: { color: "primary" }
                            },
                            [_vm._v("fa-suitcase-rolling")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "plus-button",
                              attrs: {
                                color: "success",
                                "x-small": "",
                                fab: ""
                              }
                            },
                            [_c("v-icon", [_vm._v("fa-plus")])],
                            1
                          )
                        ],
                        1
                      ),
                      _c("h3", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "travelService.orderServicesCustomerForm.orderOthers"
                              )
                            ) +
                            " "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "pa-4 text-md-center elevation-5 ma-3 add-service-buttons",
                      on: {
                        click: function($event) {
                          return _vm.$store.dispatch(
                            "TravelService/createInsuranceItem"
                          )
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "padding-left": "37px" } },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "font-size": "60px" },
                              attrs: { color: "primary" }
                            },
                            [_vm._v("fa-clinic-medical")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "plus-button",
                              attrs: {
                                color: "success",
                                "x-small": "",
                                fab: ""
                              }
                            },
                            [_c("v-icon", [_vm._v("fa-plus")])],
                            1
                          )
                        ],
                        1
                      ),
                      _c("h3", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("travelService.insurance")) + " "
                        )
                      ])
                    ]
                  ),
                  _vm.$store.state.Auth.isWnt === false
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "pa-4 text-md-center elevation-5 ma-3 add-service-buttons",
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/travel-service/pkp-intercity"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "padding-left": "37px" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { "font-size": "60px" },
                                  attrs: { color: "primary" }
                                },
                                [_vm._v("fa-suitcase-rolling")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "plus-button",
                                  attrs: {
                                    color: "success",
                                    "x-small": "",
                                    fab: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("fa-plus")])],
                                1
                              )
                            ],
                            1
                          ),
                          _c("h3", [_vm._v(" PKP Intercity ")])
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ],
        2
      ),
      _vm.contextEditedTravelServiceOrder.id === null
        ? _c("v-checkbox", {
            attrs: { label: _vm.$t("travelService.asSeparated") },
            model: {
              value: _vm.asSeparated,
              callback: function($$v) {
                _vm.asSeparated = $$v
              },
              expression: "asSeparated"
            }
          })
        : _vm._e(),
      _c("h2", [
        _vm._v(
          _vm._s(
            _vm.$t("travelService.orderServicesCustomerForm.contracting")
          ) + ":"
        )
      ]),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t(
                    "travelService.orderServicesCustomerForm.orderBy"
                  ),
                  readonly: ""
                },
                model: {
                  value: _vm.contextUser,
                  callback: function($$v) {
                    _vm.contextUser = $$v
                  },
                  expression: "contextUser"
                }
              }),
              _c("v-textarea", {
                attrs: {
                  label: _vm.$t(
                    "travelService.orderServicesCustomerForm.company"
                  ),
                  readonly: ""
                },
                model: {
                  value: _vm.company,
                  callback: function($$v) {
                    _vm.company = $$v
                  },
                  expression: "company"
                }
              }),
              _vm.availableCompanies.length > 1
                ? _c("v-select", {
                    attrs: {
                      items: _vm.availableCompanies,
                      label: _vm.$t(
                        "travelService.orderServicesCustomerForm.company"
                      ),
                      "item-text": "name",
                      "item-value": "id"
                    },
                    on: { input: _vm.updateVuexState },
                    model: {
                      value: _vm.contextEditedTravelServiceOrder.company_id,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.contextEditedTravelServiceOrder,
                          "company_id",
                          $$v
                        )
                      },
                      expression: "contextEditedTravelServiceOrder.company_id"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-2", attrs: { cols: "8" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: _vm.$t(
                    "travelService.orderServicesCustomerForm.commentAboutWholeOrder"
                  ),
                  height: "228px",
                  outlined: ""
                },
                on: { input: _vm.updateVuexState },
                model: {
                  value: _vm.contextEditedTravelServiceOrder.comment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.contextEditedTravelServiceOrder,
                      "comment",
                      $$v
                    )
                  },
                  expression: "contextEditedTravelServiceOrder.comment"
                }
              }),
              _vm.isReInvoicingForExternalContractorModuleEnabled
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pr-2", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              "item-disabled": function(v) {
                                return !v.is_enabled
                              },
                              items:
                                _vm.$store.state.TravelService
                                  .externalCustomers,
                              label: _vm.$t(
                                "delegation.form.fields.externalCustomer.name"
                              ),
                              clearable: "",
                              "item-text": "name",
                              "item-value": "id"
                            },
                            model: {
                              value:
                                _vm.contextEditedTravelServiceOrder
                                  .external_customer_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contextEditedTravelServiceOrder,
                                  "external_customer_id",
                                  $$v
                                )
                              },
                              expression:
                                "contextEditedTravelServiceOrder.external_customer_id"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pl-2", attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              hint:
                                _vm.contextEditedTravelServiceOrder
                                  .project_id === null &&
                                _vm.projectsForExternalCustomer.length > 0
                                  ? ""
                                  : _vm.$t("global.orderNumber") +
                                    ": " +
                                    _vm.externalOrderNumber,
                              "item-disabled": function(v) {
                                return !v.is_enabled
                              },
                              items: _vm.projectsForExternalCustomer,
                              label: _vm.$t(
                                "delegation.form.fields.project.name"
                              ),
                              clearable: "",
                              "item-text": "name",
                              "item-value": "id",
                              "persistent-hint": ""
                            },
                            model: {
                              value:
                                _vm.contextEditedTravelServiceOrder.project_id,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.contextEditedTravelServiceOrder,
                                  "project_id",
                                  $$v
                                )
                              },
                              expression:
                                "contextEditedTravelServiceOrder.project_id"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-form",
        { ref: "additionalParamsForm" },
        [
          _vm.contextEditedTravelServiceOrder.additional_parameters !== null &&
          _vm.contextEditedTravelServiceOrder.additional_parameters.length > 0
            ? [
                _c("h2", [
                  _vm._v(
                    _vm._s(_vm.$t("travelService.additionalParametersList")) +
                      ":"
                  )
                ]),
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  _vm._l(
                    _vm.contextEditedTravelServiceOrder.additional_parameters,
                    function(additionalParameter) {
                      return _c(
                        "v-col",
                        {
                          key: additionalParameter.ordinate,
                          staticClass: "pa-2",
                          attrs: { cols: "4" }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: additionalParameter.name,
                              rules: [
                                function(v) {
                                  return (
                                    additionalParameter.is_required === 0 ||
                                    additionalParameter.is_required === "0" ||
                                    (v != null && v.length > 0) ||
                                    _vm.$t("global.error.required")
                                  )
                                }
                              ]
                            },
                            on: { input: _vm.updateVuexState },
                            model: {
                              value: additionalParameter.value,
                              callback: function($$v) {
                                _vm.$set(additionalParameter, "value", $$v)
                              },
                              expression: "additionalParameter.value"
                            }
                          })
                        ],
                        1
                      )
                    }
                  ),
                  1
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c(
        "v-row",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: {
                disabled: _vm.$store.getters["Ajax/loading"],
                color: "blue darken-1",
                text: ""
              },
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
          ),
          _vm.canBeEdited
            ? _c(
                "v-btn",
                {
                  staticClass: "success",
                  attrs: { disabled: _vm.$store.getters["Ajax/loading"] },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "travelService.orderServicesCustomerForm.orderButton"
                        )
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c("order-service-item-dialog")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }